import axios from "axios";
import { getApiRoute } from "../utils/apiRoute";

const { REACT_APP_KIOSK_TOKEN: KIOSK_TOKEN } = process.env;

const axiosInstance = axios.create({
  baseURL: getApiRoute(),
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(KIOSK_TOKEN);
    if (token?.trim()) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.REACT_APP_ENV === "development") {
      console.error("API Error:", {
        data: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers,
        request: error.request,
        message: error.message,
        config: error.config,
      });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
